import React from "react";
import "./PageHeader.scss";

type Props = {
  title: string;
  subtitle?: string;
};

export const PageHeader: React.FC<Props> = ({ title, subtitle }) => {
  return (
    <div className="page-header">
      <h1 className="page-header-title">{title}</h1>
      {subtitle ? <p className="page-header-subtitle">{subtitle}</p> : null}
    </div>
  );
};

